import { takeLatest } from "redux-saga/effects";
import { ActionType } from "./types/actionType";
import { handleUpdateAlert, handleResetAlerts } from "./workers";

export function* watcher() {
  yield takeLatest(ActionType.UPDATE_ALERT, handleUpdateAlert);
  yield takeLatest(ActionType.RESET_ALERTS, handleResetAlerts);
}
